import Vue from 'vue';
import axios from 'axios';

export default {
 
  props: {
    items: {
      type: Array,
      required: true
    },
    selectedItems: {
      type: Array,
      required: true
    },
    displayField: {
      type: String,
      required: true
    },
    valueField: {
      type: String,
      required: true
    },
    itemsListTitle: {
      type: String,
      default: ''
    },
    selectedItemsListTitle: {
      type: String,
      default: ''
    },
    allowSort: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      selectedItem: null
    }
  },
  computed: {
    
  },
  watch: {
 
  },

  created() {
    
  },
  methods: {
    dblClickItem(value) {
      const index = this.selectedItems.findIndex(v => v == value);

      if (index >= 0)
        this.selectedItems.splice(index, 1);
      else {
        const item = this.items.filter(a => a[this.valueField] == value)[0];
        if (!item)
          return;

        this.selectedItems.push(item[this.valueField]);
      }

      this.selectedItem = null;
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    addItem() {
      if (!this.selectedItem)
        return;

      const index = this.selectedItems.findIndex(v => v == this.selectedItem);

      if (index < 0) {
        this.selectedItems.push(this.selectedItem);
      }

      this.selectedItem = null;
    },
    removeItem() {
      if (!this.selectedItem)
        return;

      const index = this.selectedItems.findIndex(v => v == this.selectedItem);

      if (index >= 0) {
        this.selectedItems.splice(index, 1);
      }

      this.selectedItem = null;
    },
    moveToUp() {
      if (!this.selectedItem)
        return;

      const index = this.selectedItems.findIndex(v => v == this.selectedItem);

      if (index > 0) {
        let rows = [this.selectedItems[index - 1], this.selectedItems[index]];

        this.selectedItems.splice(index - 1, 2, rows[1], rows[0]);
      }
    },
    moveToDown() {
      if (!this.selectedItem)
        return;

      const index = this.selectedItems.findIndex(v => v == this.selectedItem);

      if (index == this.selectedItems.length - 1)
        return;

      if (index >= 0) {
        let rows = [this.selectedItems[index], this.selectedItems[index + 1]];

        this.selectedItems.splice(index, 2, rows[1], rows[0]);
      }
    }
  }
}

